import { IPPGApi } from '@kulak91/everbeat-api-client';
import { tryCatch } from '~/utils';

class PPGService {
  constructor(private readonly api: IPPGApi) {}

  public async getPPGDataByPatientId(patientId: string) {
    return tryCatch(this.api.getPpgResults(patientId, 0, 50));
  }
}

export { PPGService };
